(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agm-vehicle-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('agm-vehicle-finder')) {
    customElements.define('agm-vehicle-finder', class extends HTMLElement {
      connectedCallback() {
        const data = JSON.parse(this.querySelector('[data-agm-vehicles]').textContent || '[]');
        const brand = this.querySelector('[data-agm-brand]');
        const model = this.querySelector('[data-agm-model]');
        const submit = this.querySelector('[data-agm-submit]');
        const soon = this.querySelector('[data-agm-soon]');
        const modelPlaceholder = model.options[0].textContent;
        [...new Set(data.map((v) => v.brand))].forEach((b) => brand.add(new Option(b, b)));
        const update = () => {
          const entry = data.find((v) => v.brand === brand.value && v.model === model.value);
          submit.disabled = !entry;
          soon.hidden = !entry || Boolean(entry.url);
          submit.dataset.url = entry && entry.url ? entry.url : '';
        };
        brand.addEventListener('change', () => {
          model.innerHTML = '';
          model.add(new Option(modelPlaceholder, ''));
          data.filter((v) => v.brand === brand.value).forEach((v) => model.add(new Option(v.model, v.model)));
          model.disabled = !brand.value;
          update();
        });
        model.addEventListener('change', update);
        submit.addEventListener('click', () => {
          if (submit.dataset.url) window.location.href = submit.dataset.url;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
